import { useQuery } from '@tanstack/react-query'

import { getCards } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCards = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!organizationId,
    queryFn: () => getCards(axiosInstance, { organizationId }),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_CARDS],
  })

  return { data, isError, isLoading }
}
